// HomeRedirect.tsx — role-aware landing for the app root (audit #9).
// A pharmacist's "what needs me" page is /dispensing, not the Inventory Dashboard; every other
// role keeps /inventory. Only the post-login/root default routes through here — deep links and
// refresh never touch it (they stay on their own URLs).
import { Navigate } from 'react-router-dom';
import { useMe } from '@/auth/useMe';
import { bestRoleFromCodes } from '@/auth/rbac';
import { useStore } from '@/store/store';

export default function HomeRedirect() {
  const { role } = useStore();
  // Real API: decide from the resolved /me roles (cached — RootLayout already gates the shell on
  // this query), not the store, whose role sync lands in an effect AFTER this Navigate would fire.
  // Mock/demo: the query is disabled, so fall back to the store's persisted QA-switcher role.
  const me = useMe();
  if (me.isLoading) return null;
  const effective = me.data?.roles?.length ? bestRoleFromCodes(me.data.roles) : role;
  return <Navigate to={effective === 'pharmacist' ? '/dispensing' : '/inventory'} replace />;
}
